"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
const INTENTION_COLLECTIONS = [{
  id: "amor",
  title: "Amor",
  description: "Piezas para abrir el corazón, cultivar el amor propio y fortalecer vínculos.",
  href: "/product-tag/amor/",
  image: "https://nuna-atelier.com/wp-content/uploads/2026/04/Amor-scaled.png"
}, {
  id: "salud",
  title: "Salud",
  description: "Objetos elegidos para acompañar bienestar, equilibrio y armonía integral.",
  href: "/product-tag/salud/",
  image: "https://nuna-atelier.com/wp-content/uploads/2026/04/Salud-scaled.png"
}, {
  id: "abundancia",
  title: "Abundancia",
  description: "Elementos con intención para expandir prosperidad, merecimiento y apertura.",
  href: "/product-tag/abundancia/",
  image: "https://nuna-atelier.com/wp-content/uploads/2026/04/Abundancia.jpeg"
}, {
  id: "paz-interior",
  title: "Paz interior",
  description: "Selección pensada para favorecer calma, serenidad y conexión contigo.",
  href: "/product-tag/paz-interior/",
  image: "https://nuna-atelier.com/wp-content/uploads/2026/04/Paz-interior-scaled.png"
}, {
  id: "proteccion",
  title: "Protección",
  description: "Piezas para limpiar, resguardar y sostener tu energía y tu espacio.",
  href: "/product-tag/proteccion/",
  image: "https://nuna-atelier.com/wp-content/uploads/2026/04/Proteccion-scaled.png"
}, {
  id: "gratitud",
  title: "Gratitud",
  description: "Objetos que acompañan prácticas de presencia, agradecimiento y conciencia.",
  href: "/product-tag/gratitud/",
  image: "https://nuna-atelier.com/wp-content/uploads/2026/04/Gratitud-2.jpeg"
}];
export default function ColeccionesDeIntencion() {
  return <section id="colecciones-de-intencion" className="relative overflow-hidden bg-background py-16 md:py-18">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[380px] w-full max-w-3xl -translate-x-1/2 rounded-full bg-primary/5 blur-[120px]" />

      <div className="container relative z-10 mx-auto max-w-6xl px-4">
        <div className="mb-12 flex flex-col items-center text-center">
          <span className="mb-3 text-sm font-medium uppercase tracking-widest text-muted-foreground">
            EXPLORA POR INTENCIÓN
          </span>

          <h2 className="mb-5 font-serif text-4xl font-medium text-foreground md:text-5xl">
            Colecciones de Intención
          </h2>

          <div className="h-px w-24 bg-primary/20" />
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
          {INTENTION_COLLECTIONS.map((item, i) => <article key={item.id} data-index={i} className="group flex h-full flex-col overflow-hidden rounded-2xl bg-background shadow-lg transition-all duration-500 hover:-translate-y-1 hover:shadow-xl">
              <div className="overflow-hidden">
                <AspectRatio ratio={4 / 3}>
                  <img src={item.image} alt={item.title} className="h-full w-full object-cover object-center transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                </AspectRatio>
              </div>

              <div className="flex flex-1 flex-col items-center p-6 text-center">
                <h3 className="mb-3 font-serif text-2xl font-medium tracking-wide text-foreground">
                  {item.title}
                </h3>

                <p className="mb-5 max-w-[92%] text-base leading-relaxed text-muted-foreground">
                  {item.description}
                </p>

                <Button variant="link" asChild className="mt-auto group/btn px-0 text-primary">
                  <Link to={item.href}>
                    Explorar
                    <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
                  </Link>
                </Button>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}